import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-business-combination',
  templateUrl: './business-combination.component.html',
  styleUrls: ['./business-combination.component.css']
})
export class BusinessCombinationComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
  }

}
